/* istanbul ignore file */
import { StaticFilters as Filters, ListFiltersLayout as FiltersLayout } from 'framework/list';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Show } from 'framework/show';
import StatusesBreadcrumbs from 'domain/projects/project/statuses/statusList/StatusesBreadcrumbs';
import { TimelineLayout, Timeline, TimelinePageLayout, TimelineRegistry } from 'framework/ui/timeline';
import useProjectDemoStatusRegistry from '../demo/projectDemoRegistry';
import useProjectStatusesService from 'domain/projects/project/statuses/ProjectStatusesService';
import ProjectEntityHeader from 'domain/projects/project/shared/ProjectEntityHeader';
import ViewProjectPageMenu from 'domain/projects/project/Show/ViewProjectPageMenu';
import { useProjectRoute, useProjectService } from 'domain/shared/project';
import ProjectStatusTypeFilter from '../shared/filter/ProjectStatusTypeFilter';
import useProjectPlanningStatusRegistry from '../planning/projectPlanningRegistry';

const ProjectStatusesList = () => {
  const oldHashStatus = '#status';
  const { id: projectId = '' } = useParams<Dictionary<string>>();
  const navigate = useNavigate();
  const location = useLocation();
  const { getSingleProjectStatusUrl } = useProjectRoute();
  const { getById } = useProjectService();
  const { search } = useProjectStatusesService();
  const statusDemoRegistry = useProjectDemoStatusRegistry();
  const statusPlanningRegistry = useProjectPlanningStatusRegistry();

  useEffect(() => {
    const { hash } = location;
    const statusId = hash && hash.includes(oldHashStatus) && hash.replace(oldHashStatus, '');

    if (statusId) {
      navigate(getSingleProjectStatusUrl(projectId, statusId), { replace: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filters = (
    <Filters>
      <FiltersLayout>
        <ProjectStatusTypeFilter label="Status Type" source="projectStatusType" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <Show getDataMethod={() => getById(projectId)}>
      <Timeline
        registries={[statusDemoRegistry, statusPlanningRegistry] as unknown as TimelineRegistry[]}
        getDataMethod={search}
      >
        <TimelinePageLayout
          menu={<ViewProjectPageMenu />}
          breadcrumbs={<StatusesBreadcrumbs />}
          entityHeader={<ProjectEntityHeader />}
          title="Project Status"
          hasAddForm={false}
          filter={filters}
        >
          <TimelineLayout noEntriesMessage="No project status yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default ProjectStatusesList;
